module.exports = __webpack_public_path__ + "static/media/logo-vivo.14370b1b.svg";